function CPRCostCenterModel(costCenter) {
    if (!costCenter) costCenter = {};
    var model = {};

    model.Code = costCenter.Code;
    model.Name = costCenter.Name;

    model.Records = [];
    for (var i = 0; i < costCenter.Records.length; i++) {
        model.Records.push(new CPRRecordModel(costCenter.Records[i]));
    }

    model.SiteTotal = function () {
        var _sitetotal = {};
        _sitetotal.AmountFullClaimsCosts = 0;
        _sitetotal.AmountClaimsCosts = 0;
        _sitetotal.AmountRecoveryAmount = 0;
        _sitetotal.AmountGrossClaimsCosts = 0;
        _sitetotal.AmountTotal = 0;
        _sitetotal.totalNumber = model.Records.length;
        _sitetotal.totalClosed = model.Records.filter(function(record) {
                                                return record.Closed === "Y";}).length;
        _sitetotal.totalClosed = _sitetotal.totalClosed ? _sitetotal.totalClosed : 0;
        _sitetotal.totalOpen = _sitetotal.totalNumber - _sitetotal.totalClosed;
        _sitetotal.TotalNumberString = _sitetotal.totalNumber + " claim(s), " + _sitetotal.totalOpen + " open, " + _sitetotal.totalClosed + " closed.";
        model.Records.forEach(function (record) {
            _sitetotal.AmountFullClaimsCosts += parseFloat(record.FullClaimsCosts);
            _sitetotal.AmountClaimsCosts += parseFloat(record.ClaimsCosts);
            _sitetotal.AmountRecoveryAmount += parseFloat(record.RecoveryAmount);
            _sitetotal.AmountGrossClaimsCosts += parseFloat(record.GrossClaimsCosts);
            _sitetotal.AmountTotal += parseFloat(record.Total);
        });

        return _sitetotal;
    }

    return model;
}